import React, { FC } from 'react';
import { RightColumnProps } from '@components/ncFileVersions/types';
import { View } from 'react-native';
import NcFileContent from '@components/common/NCFile';
import { isPhoneNative, isTabletOrWeb, isWeb } from '@helpers';
import { scale } from '@components/frame';
import { getBoxShadowStyle } from '@styles/shadow';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import Separator from '@components/common/Separator';
import VersionHeader from './VersionHeader';

const RightColumn: FC<RightColumnProps> = ({ selectedItem, C, ncFile, visible, selectedVersion, onSendToMachine }) => {
  if (!visible) return null;

  const Content = (
    <NcFileContent
      {...{
        selectedItem,
        C,
        backgroundColor: C('Background/Light/Field'),
        ncFileId: ncFile?.ncFileId!,
        ncFileName: ncFile?.ncFileName,
        singleColor: true,
        ncFileTextColor: C('Label/Light/Primary'),
        isPreview: false,
        borderTop: isPhoneNative,
        borderRadiusTop: isTabletOrWeb ? false : true,
        borderRadiusBottom: isTabletOrWeb,
        withShadow: isTabletOrWeb ? false : isWeb,
        selectedVersion,
        ...(isPhoneNative ? { paddingTop: scale(18) } : {}),
      }}
    />
  );

  if (isPhoneNative) return Content;

  const shadowStyles = getBoxShadowStyle({ type: 'Field', C });

  return (
    <View style={{ flex: 1 }}>
      <View
        style={[
          {
            flex: 1,
            backgroundColor: C('Background/Light/Field'),
            borderRadius: scale(SCREEN_BORDER_RADIUS),
            overflow: 'hidden',
          },
          isWeb && shadowStyles,
        ]}
      >
        {isTabletOrWeb && (
          <>
            <VersionHeader C={C} selectedVersion={selectedVersion} onSendToMachine={onSendToMachine} />
            <View style={{ paddingHorizontal: scale(12) }}>
              <Separator C={C} />
            </View>
          </>
        )}
        {Content}
      </View>
    </View>
  );
};

export default RightColumn;
